import { css } from "@emotion/css";
export default css({
    "& .ant-modal-body": {
        "& .ant-btn": {
            width: 206
        }
    },
});
